export const tr = {
    timezone: 'Saat dilimi'
};
